export default __webpack_public_path__ + "static/media/home-hero-img.77faa71f.jpg";